import React from 'react'
import styles from './style.module.scss'
import MyImage from '@shared/components/myImage'
import BatIcon from '@assets/images/icon/bat.svg'
import BallIcon from '@assets/images/icon/ball-run.svg'
import PartnershipIcon from '@assets/images/icon/partnership.svg'
import PropTypes from 'prop-types'

function ScorePlayerDetail({ playerData }) {
  const playerDetails = [
    { heading: 'Batting Style', value: playerData?.battingMatrix?.style || '-', icon: BatIcon },
    { heading: 'Run by Running', value: playerData?.battingMatrix?.running || '-', icon: BallIcon },
    { heading: 'Run by Boundary', value: playerData?.battingMatrix?.boundary || '-', icon: BatIcon },
    { heading: `P.ship with ${playerData?.battingMatrix?.pShip?.player || '-'}`, value: playerData?.battingMatrix?.pShip?.runs, icon: PartnershipIcon },
    {
      heading: 'Boundary %',
      value: playerData?.battingMatrix?.boundaryPercentage ? `${playerData.battingMatrix.boundaryPercentage}%` : '-',
      icon: BatIcon
    },
    { heading: `vs ${playerData?.battingMatrix?.p2p?.player || '-'}`, value: playerData?.battingMatrix?.p2p?.runs, icon: BatIcon }
  ]
  return (
    <div className={styles.playerDetailWrapper}>
      {playerDetails.map((detail, idx) => (
        <div className={styles.playerDetailCard} key={idx}>
          <span>
            <MyImage src={detail.icon} width={20} height={20} alt="icon" />
          </span>
          <div>
            <h6 className={styles.playerDetailHeading}>{detail.heading}</h6>
            <p className={styles.playerDetailsTag}>{detail.value}</p>
          </div>
        </div>
      ))}
    </div>
  )
}

ScorePlayerDetail.propTypes = {
  playerData: PropTypes.object
}

export default ScorePlayerDetail
